import React from "react"
import { Box } from "@mui/material"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import SegmentedPill from "@/components/ui/SegmentedPill"

const MUTED = "#6b7c8c"

const LEG_OPTIONS = [
  { value: "greatcircle", label: "Great circle", tooltip: "Shortest distance" },
  { value: "rhumbline", label: "Rhumb line", tooltip: "Constant course" },
]

/**
 * Leg type of the leg that starts at a manual-route waypoint, shown in its
 * info card.
 */
export default function WaypointEditSection({
  nextLabel,
  legtype = "greatcircle",
  onLegtypeChange = null,
  disabled = false,
}) {
  if (!onLegtypeChange) return null
  return (
    <Box sx={{ borderBottom: "1px solid #e2e8ee", p: "8px 12px 10px" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          mb: "6px",
          fontSize: 11,
          color: MUTED,
        }}
      >
        {nextLabel ? (
          <>
            Leg <ArrowForwardIcon sx={{ fontSize: 14 }} /> {nextLabel}
          </>
        ) : (
          "Next leg"
        )}
      </Box>
      <Box sx={disabled ? { opacity: 0.45, pointerEvents: "none" } : null}>
        <SegmentedPill
          fullWidth
          options={LEG_OPTIONS}
          value={legtype}
          onChange={(next) => {
            if (next !== legtype) onLegtypeChange(next)
          }}
        />
      </Box>
    </Box>
  )
}
